import React from 'react';

const Bio = ({ register, user }) => {
  return (
    <div className="space-y-4">
      {/* Bio */}
      <div className="flex flex-col">
        <label className="text-sm mb-1 font-semibold text-gray-900 dark:text-gray-200">
          About
        </label>
        <textarea
          {...register('bio', { value: user.bio })}
          placeholder="Write something about yourself..."
          className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800 dark:text-white dark:border-gray-600 resize-none"
          rows={4}
        />
      </div>
    </div>
  );
};

export default Bio;
